import { Message } from '@/shared/hooks/useMessages'

interface ChatMessageProps {
  message: Message
  isOwn: boolean
  currentUserId: string
}

export function ChatMessage({ message, isOwn, currentUserId }: ChatMessageProps) {
  const isSent = message.senderId === currentUserId

  return (
    <div className={`flex ${isSent ? 'justify-end' : 'justify-start'} mb-3`}>
      <div
        className={`max-w-xs px-4 py-2 rounded-2xl ${
          isSent
            ? 'bg-accent text-white rounded-br-none'
            : 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white rounded-bl-none'
        }`}
      >
        {!isSent && message.sender?.profile?.name && (
          <div className="text-xs font-semibold mb-1 opacity-70">
            {message.sender.profile.name}
          </div>
        )}
        <p className="text-sm break-words">{message.content}</p>
        <div className={`text-xs mt-1 ${isSent ? 'text-white/70' : 'text-gray-600 dark:text-gray-300'}`}>
          {new Date(message.createdAt).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
          })}
          {isSent && message.readAt && ' ✓✓'}
        </div>
      </div>
    </div>
  )
}
